import { render, staticRenderFns } from "./investmentReport.vue?vue&type=template&id=5811a1fc&"
import script from "./investmentReport.vue?vue&type=script&lang=js&"
export * from "./investmentReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports